import { formatText } from "bernie-l10n";

/**
 * Returns a text corresponding to the rating given.
 * 0-3.4: Withhold superlative
 * @param {number} rating - Number between 0-5 representing average rating of hotel
 * @return {string}
 */
export const getRatingText = (rating: number): string => {
  switch (true) {
    case rating <= 3.4:
      return "";
    case rating <= 3.9:
      return formatText("hotels.review.ratingCategory1");
    case rating <= 4.2:
      return formatText("hotels.review.ratingCategory2");
    case rating <= 4.4:
      return formatText("hotels.review.ratingCategory3");
    case rating <= 4.6:
      return formatText("hotels.review.ratingCategory4");
    case rating <= 5:
      return formatText("hotels.review.ratingCategory5");
    default:
      return "";
  }
};
